export { default } from './link';
